import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Code = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path d="M8.79775 3.73663L5.79775 11.7366L7.20224 12.2633L10.2022 4.26332L8.79775 3.73663Z" fill="currentColor" />
    <path
      d="M4.46966 11.0303L1.43933 7.99998L4.46966 4.96965L5.53032 6.03031L3.56065 7.99998L5.53032 9.96965L4.46966 11.0303Z"
      fill="currentColor"
    />
    <path
      d="M11.5303 4.96965L14.5607 7.99998L11.5303 11.0303L10.4697 9.96965L12.4393 7.99998L10.4697 6.03031L11.5303 4.96965Z"
      fill="currentColor"
    />
  </Icon>
));

export default Code;
